const KYC_CARD_SHOW_LOGIN_COUNT = {
  MAX: 10,
  MIN: 2,
};

export { KYC_CARD_SHOW_LOGIN_COUNT };
